// const apiUrl = 'http://192.168.1.121:8866/buyCard';
const apiUrl = 'http://ywmall.yuantel.com/lightsdk/buyCard';
 //const apiUrl = 'http://ywmall.yuantel.com/lightsdk_test/buyCard';

export default apiUrl;